module.exports = __webpack_public_path__ + "static/media/samoa-flag-square-medium.d7b38088.png";